import { Card, DatePicker, Space, Table, Typography } from 'antd'

import React, { useEffect, useState } from 'react'
import { staffReportApi } from '../../services/reports';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
const { Title } = Typography;
const { RangePicker } = DatePicker;


export default function StaffReport() {
    let {tenantId} = useParams()
    const [staffData,setStaffData] = useState([])
     const [dateRange, setDateRange] = useState([
        dayjs().subtract(1, "month"),
        dayjs(),
      ]);
      const [loading, setLoading] = useState(false);
    useEffect(()=>{
        getStaffReport(dateRange[0], dateRange[1])
    },[])

    const getStaffReport = async (startDate, endDate)=>{
       let res = await  staffReportApi({startDate,endDate,tenantId})
       if(res?.list) setStaffData(res?.list)
        else toast.error('No data found !')
    }


     const columns = [
    {
      title: "Staff Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    // {
    //   title: "Tenant ID",
    //   dataIndex: "tenantId",
    //   key: "tenantId",
    // },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    //   render: (value) => `₹ ${value?.toLocaleString()}`,
    },
     {
      title: "Total Clients",
      dataIndex: "totalClient",
    //   key: "companyName",
      render: (value,record) => {
        return (
            <p>{record?.clientNames?.length}</p>
        )
      },
    },
  ];
    const handleDateChange = (dates) => {
    if (!dates) return;
    setDateRange(dates);
    getStaffReport(dates[0], dates[1]);
  };
 return (
    <Card>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", rowGap: 10 }}>
          <Title level={4}>Staff Report</Title>
          <RangePicker
            value={dateRange}
            onChange={handleDateChange}
            allowClear={false}
          />
        </div>
        <Table
          dataSource={staffData}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={{ pageSize: 5 }}
        />
      </Space>
    </Card>)
}
